<template lang="pug">
  table.table(:class="{'is-bordered': isBordered}")
    slot
</template>

<script>
  export default {
    name: "table",
    props: {
      isBordered: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../../assets/stylesheets/--new/styles";
  .table {
    width: 100%;
    max-width: 100%;
    margin: 0;
    border-collapse: collapse;

    &.is-bordered {
      border: 1px solid $gray-light;

      > thead,
      > tbody,
      > tfoot {
        > tr {
          > th,
          > td {
            border: 1px solid $gray-light;
          }
        }
      }
    }

    > thead,
    > tbody,
    > tfoot {
      > tr {
        > th,
        > td {
          border-top: 1px solid $gray-light;
          vertical-align: top;
          line-height: 1.5;
          @include padding(xxs);
          @include font-size(xs);
        }
      }
    }

    > thead {
      > tr {
        &:first-child {
          > th,
          > td {
            border-top: none;
          }
        }

        > th {
          vertical-align: bottom;
          border-bottom: 2px solid $gray-light;
        }
      }
    }
  }
</style>
